import React from "react";
import GiottoProjects from "../shared/GiottoProjects";

/**
 * Global view of all Giotto client projects across all organizations
 */
const GiottoClientProjects = () => {
  return (
    <GiottoProjects 
      orgId={null}
      showBreadcrumb={true}
      showTitle={true}
      showTabs={false}
    />
  );
};

export default GiottoClientProjects;
